import { useMutation } from 'react-query';
import { request } from '../../../config/helpers/axios-instance';
import { toast } from 'react-toastify';

const triggerXlsxDownload = (blobData, from, to) => {
    const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `gst_invoice_export_${from}_to_${to}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

const useGstInvoiceExport = () =>
    useMutation(
        ({ from, to, invoiceType, documentType, useStoredTaxes }) =>
            request({
                url: 'paymentItem/export/gst-invoices',
                method: 'GET',
                params: { from, to, invoiceType, documentType, useStoredTaxes },
                responseType: 'blob',
            }),
        {
            onSuccess: (response, vars) => {
                triggerXlsxDownload(response.data, vars.from, vars.to);
                toast.success('GST invoice export downloaded');
            },
            onError: async (error) => {
                // GOTCHA: with responseType:'blob', a JSON error body comes back as a Blob.
                // Read it back as text to surface the real message.
                let msg = 'Failed to export GST invoices';
                try {
                    const text = await error?.response?.data?.text?.();
                    if (text) msg = JSON.parse(text)?.error || msg;
                } catch (_) { /* keep default */ }
                toast.error(msg);
            },
        }
    );

export default useGstInvoiceExport;
